import * as React from 'react';

import { useTranslation } from 'react-i18next';

import type { TabsType } from '@types';

import { BUTTON_SIZE } from '@components/button/types';

import * as Styled from './tabs.styled';

type OwnProps = {
	tabList: TabsType[];
	activeTab: string;
	setActiveTab: (id: string) => void;
	isGray?: boolean;
	isWide?: boolean;
	minWidth?: number;
	size?: Lowercase<keyof typeof BUTTON_SIZE>;
	isRounded?: boolean;
};

const Tabs: React.FC<OwnProps> = ({
	tabList,
	setActiveTab,
	activeTab,
	isGray,
	isWide,
	minWidth,
	size = 'medium',
	isRounded
}) => {
	const { t } = useTranslation('');
	return (
		<Styled.Wrapper $isWide={isWide} $isRounded={isRounded}>
			{tabList.map(tab => (
				<Styled.Tab
					key={tab.id}
					$isActive={tab.id === activeTab}
					onClick={() => setActiveTab(tab.id)}
					$isGray={isGray}
					$isWide={isWide}
					$minWidth={minWidth}
					$size={size}
					$isRounded={isRounded}
				>
					{t(tab.name)}
				</Styled.Tab>
			))}
		</Styled.Wrapper>
	);
};

export default React.memo(Tabs);
